import React from 'react'

import Content from 'components/base/Content'
import Title from 'components/base/Title'

import UserSuppliedText from 'components/base/UserSuppliedText'
import QuotingWrapper, { Theme as QuotingWrapperTheme } from 'components/blocks/QuotingWrapper'

import { Props } from './types'

const Medicare: React.FC<Props> = ({ applicantFirstName }): React.ReactElement => (
  <QuotingWrapper noPadding={true} theme={QuotingWrapperTheme.medicare}>
    <Content center={true}>
      <Title level={3}>
        Thanks<UserSuppliedText>{(applicantFirstName && `, ${applicantFirstName}`) || undefined}</UserSuppliedText>.
        <br />
        Please provide your information so we can quote your medicare policy.
      </Title>
    </Content>
    <Content center={true} margined={true} short={true}>
      <iframe width='100%' scrolling='no' height='400' frameBorder='0' title='Medicare CSG' src='https://www.freemedicarereport.com/comparison_form/insurancelounge.com?bg_color=5f5f5f&cta_color=01b0f1&plan=G' />
    </Content>
  </QuotingWrapper>
)

export default Medicare
